module.exports = __webpack_public_path__ + "img/characterAnime11.87b632e3.png";